module.exports = __webpack_public_path__ + "img/научная-статья-540x280.befd990d.jpg";